import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import {
  House, Users, Receipt, Stack, Cube, SignOut, Plus, Gear, Funnel,
} from "@phosphor-icons/react";
import { useAuth } from "../context/AuthContext";

const links = [
  { to: "/", label: "Dashboard", icon: House, end: true },
  { to: "/pipeline", label: "Pipeline", icon: Funnel },
  { to: "/customers", label: "Customers", icon: Users },
  { to: "/quotes", label: "Quotes", icon: Receipt },
  { to: "/roof-types", label: "Roof Types", icon: Cube },
  { to: "/materials", label: "Materials", icon: Stack },
  { to: "/settings", label: "Branding", icon: Gear },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex bg-[var(--rqp-bg)]">
      <aside className="w-60 shrink-0 bg-white border-r border-slate-300 flex flex-col" data-testid="app-sidebar">
        <div className="px-5 py-5 border-b border-slate-200 flex items-center gap-2">
          <div className="w-9 h-9 grid place-items-center bg-[var(--rqp-orange)] rounded-sm">
            <svg viewBox="0 0 24 24" className="w-5 h-5" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinejoin="round">
              <path d="M3 12 L12 4 L21 12 L18 12 L18 20 L6 20 L6 12 Z" />
            </svg>
          </div>
          <div className="leading-tight">
            <div className="font-display font-bold text-[15px] tracking-tight">RoofQuote</div>
            <div className="text-[10px] font-bold tracking-[0.18em] text-[var(--rqp-orange)] uppercase">PRO</div>
          </div>
        </div>
        <nav className="px-2 py-4 flex-1">
          {links.map((l) => {
            const Icon = l.icon;
            return (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) => `side-link ${isActive ? "active" : ""}`}
              >
                <Icon size={18} weight="bold" />
                <span>{l.label}</span>
              </NavLink>
            );
          })}
        </nav>
        <div className="border-t border-slate-200 p-3">
          <div className="text-xs font-mono-data text-slate-500 truncate" data-testid="sidebar-user-email">
            {user?.email}
          </div>
          <div className="text-[10px] text-slate-400 uppercase tracking-wider mt-0.5">
            {user?.company || user?.role}
          </div>
          <button
            data-testid="sidebar-logout-button"
            onClick={async () => { await logout(); navigate("/login"); }}
            className="mt-3 w-full btn-secondary flex items-center justify-center gap-2 text-xs"
          >
            <SignOut size={14} weight="bold" /> Sign out
          </button>
        </div>
      </aside>

      <main className="flex-1 min-w-0">
        <Outlet />
      </main>
    </div>
  );
}
